// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:00:20

export default {
  "id": "children-s-doctor-treating-ears",
  "slug": "children-s-doctor-treating-ears",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/296514e59a8e41f2b6a5dfcb2bad9461-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/296514e59a8e41f2b6a5dfcb2bad9461/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Children's doctor: treating ears",
      "description": "Ready to become the best pediatric doctor in the world? Learn to use medical instruments, give first aid to patients? Play our doctor without downloads, registration and absolutely free!",
      "instructions": "Use your mouse (to play on your computer), or your finger (to play on your phone) to click and control the ✂ instruments you have chosen to treat patients.\n\nFollow the on-screen prompts and you'll start to succeed very soon!",
      "genres": [
        "Care",
        "Casual"
      ],
      "tags": [
        "2d",
        "doctor",
        "girls"
      ]
    },
    "zh-CN": {
      "title": "儿童医生：治疗耳朵",
      "description": "准备好成为世界上最好的儿科医生了吗？学习使用医疗器具，为患者提供急救？玩我们的医生游戏，无需下载、注册，完全免费！",
      "instructions": "使用您的鼠标（在电脑上玩游戏）或手指（在手机上玩游戏）来点击和控制您选择的✂手术工具来治疗患者。\n\n遵循屏幕上的提示，您很快就会开始取得成功！",
      "genres": [
        "关怀",
        "休闲"
      ],
      "tags": [
        "2D",
        "医生",
        "女孩"
      ]
    },
    "zh-TW": {
      "title": "兒童醫生：治療耳朵",
      "description": "準備成為世界上最棒的兒科醫生嗎？學習使用醫療儀器，為病人提供急救？無需下載、註冊，絕對免費，玩我們的醫生遊戲！",
      "instructions": "使用您的滑鼠（在電腦上遊玩）或手指（在手機上遊玩）來點擊並控制您選擇治療病患的✂工具。\n\n隨著螢幕上的指示操作，您將很快就能獲得成功！",
      "genres": [
        "關心",
        "隨意"
      ],
      "tags": [
        "2D",
        "醫生",
        "女孩"
      ]
    },
    "zh-HK": {
      "title": "兒童醫生：治療耳朵",
      "description": "準備成為世界最佳兒科醫生嗎？學習使用醫療儀器，對患者進行急救？免下載、免註冊、絕對免費，玩我們的醫生遊戲！",
      "instructions": "使用你的滑鼠（在電腦上玩遊戲），或你的手指（在電話上玩遊戲）去點擊和控制你選擇的✂醫療工具來治療病人。\n\n依照螢幕上的指示，你很快就能成功！",
      "genres": [
        "關心",
        "休闲"
      ],
      "tags": [
        "二維",
        "醫生",
        "少女"
      ]
    },
    "ja": {
      "title": "子供の医師：耳の治療",
      "description": "世界で最も優れた小児科医になる準備はできましたか？医療機器の使い方を学び、患者に緊急処置を施す方法を学びますか？ダウンロードや登録が不要で、完全に無料で当ての医師ゲームを遊んでください！",
      "instructions": "マウス（コンピュータで遊ぶ場合）または指（スマートフォンで遊ぶ場合）を使って、患者を治療するために選んだ✂器具をクリックして操作してください。\n\nスクリーンの指示に従えば、すぐに成功し始めるでしょう！",
      "genres": [
        "注意",
        "カジュアル"
      ],
      "tags": [
        "2D",
        "医師",
        "少女"
      ]
    },
    "ko": {
      "title": "아동의사: 귀 치료",
      "description": "세계에서 가장优秀的 소아과 의사가 되어보세요? 의료 도구를 사용하는 방법을 배우고, 환자에게 응급처치를 해보세요? 다운로드 없이, 등록 없이, 완전히 무료로 우리의 의사 게임을 플레이하세요!",
      "instructions": "컴퓨터에서 플레이할 때는 마우스를 사용하거나(폰에서 플레이할 때는 손가락을 사용하여) 선택한 ✂ 도구를 클릭하고 조절하세요.\n\n화면에 나오는 안내를 따르면 곧 성공하게 될 거예요!",
      "genres": [
        "주의",
        "캐주얼"
      ],
      "tags": [
        "2D",
        "의사",
        "소녀"
      ]
    },
    "fr": {
      "title": "Médecin pour enfants : traitement des oreilles",
      "description": "Prêt à devenir le meilleur pédiatre du monde ? Apprenez à utiliser des instruments médicaux, à prodiguer des premiers secours aux patients ? Jouez à notre jeu de docteur sans téléchargement, inscription et complètement gratuit !",
      "instructions": "Utilisez votre souris (pour jouer sur votre ordinateur) ou votre doigt (pour jouer sur votre téléphone) pour cliquer et contrôler les instruments ✂ que vous avez choisis pour traiter les patients.\n\nSuivez les instructions à l'écran et vous verrez que vous réussirez très bientôt !",
      "genres": [
        "Prudence",
        "Occasionnel"
      ],
      "tags": [
        "2D",
        "docteur",
        "filles"
      ]
    }
  }
};
